import { Injectable } from '@angular/core';

import { AgentServiceBase } from './agent-service-base';

/**
 * Assistant du manuel utilisateur : il répond aux questions de mode d'emploi en
 * s'appuyant sur les articles publiés et cite celui dont il tire sa réponse.
 *
 * Il ne diffère de l'assistant général que par son code d'agent : le serveur en
 * tire un `Prompt` distinct — instruction système propre et outils documentaires
 * — et le transport reste le même relay SSE.
 */
@Injectable({
    providedIn: 'root'
})
export class AiDocumentationAgentService extends AgentServiceBase {

    protected override get agentName(): string {
        return 'documentation';
    }

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    private _contextKey: string | null = null;

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    /**
     * Rattache la conversation en cours au contexte depuis lequel on s'apprête à
     * parler. Un contexte différent ouvre une conversation neuve : un fil dont la
     * première question annonce un écran qu'on a quitté mentirait sur lui-même.
     *
     * Le manuel — accueil, page d'article, fenêtre d'article — n'est qu'un seul
     * contexte : y passer d'un article à l'autre, c'est la même exploration.
     */
    public useContext(key: string): void {
        if (key === this._contextKey) {
            return;
        }
        this._contextKey = key;
        this.clear();
    }
}
